import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SelectableTableComponent from './SelectableTableComponent'

const propTypes = {
  tables: PropTypes.array.isRequired,
  selectedTable: PropTypes.object,
  map: PropTypes.object,
  onTableSelection: PropTypes.func.isRequired,
  currentTransaction: PropTypes.object
}

class PlanSelectionComponent extends Component {
  render() {
    const { tables, selectedTable, map, currentTransaction } = this.props
    const planContainerStyle = {
      width: Number(map.width) / 2 + 40,
      height: Number(map.height) / 2 + 40
    }
    return (
      <div className="planContainer small" style={planContainerStyle}>
        {tables.map(table => {
          const isSelected = selectedTable && selectedTable.key === table.key
          const selectable =
            (currentTransaction && !table.currentTransaction) ||
            (!isSelected &&
              ((currentTransaction || {}).key !==
                ((table || {}).currentTransaction || {}).key &&
                !!((table || {}).currentTransaction || {}).sale_id))
          return (
            <SelectableTableComponent
              key={table.key}
              table={table}
              currentTransaction={currentTransaction}
              selectable={selectable}
              isSelected={isSelected}
              onSelect={this.props.onTableSelection}
            />
          )
        })}
      </div>
    )
  }
}

PlanSelectionComponent.propTypes = propTypes
export default PlanSelectionComponent



// WEBPACK FOOTER //
// ./src/components/SelectionTabsComponent/PlanSelectionComponent.js